export const minKmOptions = [0, 10, 20, 30, 40, 50, 60, 80, 100];
export const maxKmOptions = [10, 20, 30, 40, 50, 60, 80, 100];
export const minPriceOptions = [
  0, 10, 20, 30, 40, 50, 60, 70, 80, 100, 120, 150, 200, 300,
];
export const maxPriceOptions = [
  10, 20, 30, 40, 50, 60, 70, 80, 100, 120, 150, 200, 300,
];
